/**
 * @generated SignedSource<<7cb727f27a182e0dfd280d542dedcc90>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PhotosSearchBrowseSocialIcons_photo$data = {
  readonly designFirm: {
    readonly name: string | null;
  } | null;
  readonly id: string;
  readonly path: string | null;
  readonly photoLike: {
    readonly totalPhotoLikes: number | null;
  } | null;
  readonly project: {
    readonly name: string | null;
    readonly url: string | null;
  } | null;
  readonly serviceId: string | null;
  readonly url: string | null;
  readonly " $fragmentType": "PhotosSearchBrowseSocialIcons_photo";
};
export type PhotosSearchBrowseSocialIcons_photo$key = {
  readonly " $data"?: PhotosSearchBrowseSocialIcons_photo$data;
  readonly " $fragmentSpreads": FragmentRefs<"PhotosSearchBrowseSocialIcons_photo">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PhotosSearchBrowseSocialIcons_photo",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "path",
      "storageKey": null
    },
    (v0/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PhotosSearchBrowsePhotoProject",
      "kind": "LinkedField",
      "name": "project",
      "plural": false,
      "selections": [
        (v1/*:: as any*/),
        (v0/*:: as any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "DesignFirm",
      "kind": "LinkedField",
      "name": "designFirm",
      "plural": false,
      "selections": [
        (v1/*:: as any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PhotoLike",
      "kind": "LinkedField",
      "name": "photoLike",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalPhotoLikes",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "PhotosSearchBrowsePhoto",
  "abstractKey": null
};
})();

(node as any).hash = "472987fb003b5619efb26aca8641193b";

export default node;
